export default "__VITE_ASSET__M_HXzpjI__"